import { render } from "./ExpandableImage.vue?vue&type=template&id=ad4a740e"
import script from "./ExpandableImage.vue?vue&type=script&lang=js"
export * from "./ExpandableImage.vue?vue&type=script&lang=js"

import "./ExpandableImage.vue?vue&type=style&index=0&id=ad4a740e&lang=css"

import exportComponent from "D:\\Xoan\\asp-user\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__